
<template>
    <video 
        ref="video"
        :src="videoSrc"
        @canplay="onCanPlay"
        @canplaythrough="onLoaded"
        @timeupdate="onUpdatePlayback"
        :class="{'loaded': this.loaded}" 
        
        :loop="loop"
        :autoplay="autoplay"
        :muted="muted"
        :playsinline="playsinline"
        />
</template>


<script>
// Use IntersectionObserver to know if video is within viewport - https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API


export default {
    props: {
        data: {
            type: Array,
            required: true,

            // EXAMPLE data - Array with src, widht & height
            // [
            //     {
            //         "url": "video-768x432.mp4",
            //         "width": 768,
            //         "height": 432
            //     },
            //     {
            //         "url": "video-1080x608.mp4",
            //         "width": 1080,
            //         "height": 608
            //     },
            //     {
            //         "url": "video-1920x1080.mp4",
            //         "width": 1920,
            //         "height": 1080
            //     }
            // ]
        },
        
        // // We load video depending on container width. containerWidth is updated on resize.
        // containerWidth: {
        //     type: Number,
        //     required: true,
        // }
        
        autoplay: {
            type: Boolean,
            default: false,
        },
        loop: {
            type: Boolean,
            default: false,
        },
        intersectionOptions: {
            type: Object,
            default: () => ({})
        },
    },
    
    
    data() {
        return {
            observer: null,
            intersected: false,
            loaded: false,
            width: 0,
            height: 0,
            
            muted: true,
            volume: 0,
            playsinline: false,
        }
    },
    
    mounted() {
        
        // https://caniuse.com/#search=intersectionobserver
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
                const el = entries[0]
                if (el.isIntersecting) {
                    this.intersected = true
                    this.observer.disconnect()
                }
            }, this.intersectionOptions)
        
            // Check if element is within viewport
            this.observer.observe(this.$el)
        
        } 
        // Fallback for older browsers
        else {
            this.intersected = true // Load all assets even if they are not within viewport
        }
        
        // containerWidth must be value over 0
        // if (this.containerWidth > 0) {}
        
        this.setVideoSrc()
        
    },
    
    destroyed() {
        if ('IntersectionObserver' in window) {
            this.observer.disconnect()
        }
    },
    
    methods: {
        
        setVideoSrc() {
            
            // ONE video size
            this.src = this.data[0].url
            this.width = this.data[0].width
            this.height = this.data[0].height
            this.padding = (this.height/this.width)*100
            
            // Set video src depending on container width
            // for (var i = 0; i < this.data.length; i++) {
            //     var video = this.data[i]
            // 
            //     // Load asset depending on size
            //     if (video.width > this.$refs.videoContainer.offsetWidth) {
            //         if (this.src === video.url) {
            //             return
            //         }
            //         this.src = video.url
            //         this.width = video.width
            //         this.height = video.height
            //         this.padding = (video.height/video.width)*100
            //         return
            //     }
            // }
        },
        
        onCanPlay() {
            // console.log('video canPlay')
        },
        
        onLoaded() {
            if (!this.$refs.video) return
            
            if (this.loop === true) {
                this.$refs.video.loop = true
            }
            
            if (this.autoplay === true) {                
                this.playsinline = true
                this.muted = true
                this.$refs.video.volume = 0
                this.$refs.video.play()
            }
            
            this.loaded = true
            this.$emit('loaded')
        },
        
        onUpdatePlayback() {
            this.$emit('progress')
        },
        
        play() {
            if (!this.loaded) return;
            this.$refs.video.play()
        },
        
        pause() {
            if (!this.loaded) return;
            this.$refs.video.pause()
        }
    },
    
    // ContainerWidth change - Check if we need to load new video asset
    // watch: {
    //     containerWidth: function(newVal) {
    //         if (newVal > 0) {
    //             this.setVideoSrc()
    //         }
    //     }
    // },
    
    computed: {
        videoSrc() {
            return (this.intersected === true) ? this.src : false
        },
    }
}


</script>


<style lang="scss" scoped>

video {
    width: 100%;
    height: auto;
}
</style>
